<template>
  <vs-card>
    <div slot="header">
      <h3>Análise Técnica</h3>
    </div>
    <div>
      <div class="vx-row mt-4">
        <!-- Análise de vistoria Prévia -->
        <div class="vx-col sm:w-1/3 xl:w-3/12 w-full mb-2">
          <label class="vs-input--label">Análise de vistoria Prévia</label>
          <vs-switch
            v-model="formAnaliseTecnica.analiseVistoriaPrevia"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Monta conforme análise -->
        <div class="vx-col sm:w-2/3 xl:w-1/4 w-full mb-2">
          <label class="vs-select--label">Monta conforme análise</label>
          <v-select
            :options="listMonta"
            name="Monta"
            id="Monta"
            v-model="formAnaliseTecnica.idMonta"
            label="label"
            :reduce="(item) => item.id"
          ></v-select>
        </div>

        <!-- Evento Aprovado -->
        <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
          <label class="vs-input--label">Sinistro Aprovado</label>
          <vs-switch
            v-model="formAnaliseTecnica.eventoAprovado"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Perda Total -->
        <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
          <label class="vs-input--label">Perda Total</label>
          <vs-switch
            v-model="formAnaliseTecnica.perdaTotal"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Sindicância -->
        <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
          <label class="vs-input--label">Sindicância</label>
          <vs-switch
            v-model="formAnaliseTecnica.sindicancia"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mt-4">
        <!-- Aviso de Evento Segurado/Terceiro coincidem -->
        <div class="vx-col sm:w-1/3 xl:w-3/12 w-full mb-2">
          <label class="vs-input--label"
            >Aviso de Evento Segurado/Terceiro coincidem</label
          >
          <vs-switch
            v-model="formAnaliseTecnica.avisoAssociadoTerceiroConincidem"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Terceiro informações diverventes -->
        <div class="vx-col sm:w-1/3 xl:w-3/12 w-full mb-2">
          <label class="vs-input--label"
            >Terceiro informações diverventes</label
          >
          <vs-switch
            v-model="formAnaliseTecnica.terceiroInformacoesDiverventes"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
      </div>

      <!-- Informações divergentes -->
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <vs-textarea
            label="Informações divergentes"
            v-model="formAnaliseTecnica.informacoesDiverventes"
          />
        </div>
      </div>

      <!-- Resumo do Analista -->
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <vs-textarea
            label="Resumo do Analista"
            v-model="formAnaliseTecnica.resumoAnalista"
          />
        </div>
      </div>

      <!-- Conclusão do Comitê -->
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <vs-textarea
            label="Conclusão do Comitê"
            v-model="formAnaliseTecnica.conclusaoComite"
          />
        </div>
      </div>
    </div>
  </vs-card>
</template>

<script>
import vSelect from 'vue-select';

export default {
  props: ['formData', 'dominios'],
  watch: {
    formData(value) {
      if (!value.analiseTecnica) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - ANALISE TECNICA FORM');
        return;
      }

      this.formAnaliseTecnica = Object.assign(
        this.formAnaliseTecnica,
        value.analiseTecnica,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.analiseTecnica = this.formAnaliseTecnica;
    },
  },
  components: {
    vSelect,
  },
  data() {
    return {
      formAnaliseTecnica: {
        analiseVistoriaPrevia: false,
        eventoAprovado: false,
        perdaTotal: false,
        sindicancia: false,
        idMonta: null,
        resumoAnalista: null,
        conclusaoComite: null,
        avisoAssociadoTerceiroConincidem: null,
        terceiroInformacoesDiverventes: null,
        informacoesDiverventes: null,
      },
      listMonta: [],
    };
  },
  mounted() {
    if (!this.formData.analiseTecnica) {
      console.error('ERRO NO CONTRATO DO OBJETO - ANALISE TECNICA FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.analiseTecnica = this.formAnaliseTecnica;

    if (this.dominios) {
      this.listMonta = this.dominios.listMonta;
    }
  },
};
</script>
